const TAGLIKE = /[<>]/g

/**
 * Removes characters that can form HTML tags from user- or API-controlled search strings.
 * Defense in depth for search UI; React text nodes already escape — this blocks tag delimiters.
 */
export function sanitizeSearchInput(value) {
  if (value == null || value === '') return ''
  return String(value).replace(TAGLIKE, '').replace(/\0/g, '')
}
